export const dummyCalendarData = require("./calendar_main_api.json");
